module.exports = __webpack_public_path__ + "static/media/SaleListingShortage.a41159b0.svg";